import React from 'react'
import { createPortal } from 'react-dom'
import Loading from '../utils/Loading'
import Header from './Header'
import styled from 'styled-components'
import { useState } from 'react'
import { useEffect } from 'react'
import { getMethod } from '../Apis/apis'
import { Link } from 'react-router-dom'

const Container = styled.div`
    max-width: 480px;
    height: 100vh;
    overflow: scroll;
    opacity: 1;
    margin: 0 auto;
    position: relative;
    background-color: #F4F4F4;
`

const ContainerDiv = styled.div`
   padding: 20px 20px 20px 20px;
   min-height: 300px;
`

const Title = styled.h4`
   color: ${props => props.theme.primary};
   font-size: 20px;
   font-weight: bold;
   position: relative;
   text-align: center;
   margin-bottom: 20px;

   span {
    width: 130px;
    height: 4px;
    background-color: #000;
    display: block;
    position: absolute;
    left: 50%;
    transform: translate(-50%,0);
    bottom: -8px;
    border-radius: 10px;
   }
`

const Para = styled.p`
   margin-bottom: 10px;
   color: #000;
   font-size: 17px;
   text-align: justify;
   text-indent: 50px;
   word-spacing: 0.5px;
   letter-spacing: 0.5px;
   word-wrap: break-word;
`

const LinkContainer = styled.div`
   display: flex;
   justify-content: center;
`

const TextSpan = styled.span`
   color: #000;
   text-align: center;
   display: block;
   margin-bottom: 10px;
`

const WebsiteLink = styled.div`
   background-color: ${props => props.theme.primary};
   color: #FFF;
   width: 100%;
   text-align: center;
   padding: 15px;
   border-radius: 10px;
`

const AboutUs = () => {
  const [loading,setLoading] = useState(false);
  const [data,setData] = useState([]);

  useEffect(()=>{
    (async()=>{
       const res = await getMethod('/about-us');
       if(res){
         if(res.data){
           setData(res.data);
           setLoading(false);
         }
       };
    })();
 },[]);

  return (
    <Container>
      <Header status={true} />
    <ContainerDiv>
        {
          data.length > 0 &&
            <>
              <Title>About Us
                  <span></span>
              </Title>
              <Para>
                  {data[0].text}
              </Para>
            </>
        }
    </ContainerDiv>
    <LinkContainer>
        {
          data.length > 0 &&
          <div style={{width: '200px'}}>
              <TextSpan>တရားဝင် ဝဘ်ဆိုဒ်</TextSpan>
              <a href={data[0].link} rel="noreferrer" target="_blank">
                  <WebsiteLink>Open Browser</WebsiteLink>
              </a>
          </div>
        }
    </LinkContainer>
    {
        createPortal( loading && <Loading />, document.getElementById("portal"))
    }
    </Container>
  )
}

export default AboutUs
